module.exports = __webpack_public_path__ + "static/ebquad_0-2f715b471350e54cf8020a781d74d5dc.jpg";